export const GITHUB_ICON_EXPERIMENT_NAME = 'github_icon_in_jira_all_apps_experiment';
export const GITHUB_ICON_EXPERIMENT_PARAM = 'isEnabled';
export const GITHUB_ICON_EXPERIMENT_DEFAULT = 'false';
